import { getPhantom, type PhantomApi } from './controller'

export const usePhantom = (): PhantomApi => getPhantom()
